import { render, staticRenderFns } from "./LocationLander.vue?vue&type=template&id=437be32e&scoped=true&"
import script from "./LocationLander.vue?vue&type=script&lang=js&"
export * from "./LocationLander.vue?vue&type=script&lang=js&"
import style0 from "./LocationLander.vue?vue&type=style&index=0&id=437be32e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437be32e",
  null
  
)

export default component.exports